import React from 'react';
import {
  Box,
  Button,
  Typography,
  Avatar,
  ImageList,
  ImageListItem,
  List,
  ListItem,
  TextareaAutosize,
} from '@mui/material';
import {
  AddIcon,
  CalendarIcon,
  EllipsisIcon,
  XIcon,
} from '../../components/GamifyIcon';
import DealOptionsMenu from './DealOptionsMenu';
import Moment from 'moment/moment';
import DisplayMedia from '../../components/DisplayMedia';

export default function SelectedDealDisplay({ props }) {
  // console.log('selected deal display props: ', props);
  const {
    mainDisplayAttrs,
    fullName,
    dealStage,
    ownerProfilePicture,
    currentOwnerID,
    initials,
    assigneeName,
    appointments,
    comments,
    metaData,
    setAddDealOpen,
    setSortOpen,
    selectedDealOptionsOpen,
    setSelectedDealOptionsOpen,
    selectedDealMetaDataOpen,
    setSelectedDealMetaDataOpen,
    getData,
    userId,
    searchStage,
    dealTypesCategoryIdMap,
    dealFilter,
    categoryId,
    searchString,
    fromDealPage,
    setIsLoaded,
  } = props;
  //   const [selectedDealOptionsOpen, setSelectedDealOptionsOpen] = useState(false);

  // console.log('SelectedDealDisplay appointments: ', appointments);
  // console.log('SelectedDealDisplay comments: ', comments);
  // console.log('SelectedDealDisplay metaData: ', metaData);
  // console.log('SelectedDealDisplay ownerProfilePicture: ', ownerProfilePicture);
  // console.log('SelectedDealDisplay currentOwnerID: ', currentOwnerID);

  const handleSelectedDealOptionsClick = () => {
    setSelectedDealOptionsOpen(!selectedDealOptionsOpen);
    setAddDealOpen(false);
    setSortOpen(false);
  };

  const handleAddAppointment = () => {
    console.log('handleAddAppointment placeholder');
  };

  const handleAppointmentOptionsClick = () => {
    console.log('handleAppointmentOptionsClick placeholder');
  };

  const handleAddPhoto = () => {
    console.log('handleAddPhoto placeholder');
  };

  const handleImageClick = () => {
    console.log('handleImageClick placeholder');
  };

  const handleDeleteImageClick = () => {
    console.log('handleDeleteImageClick placeholder');
  };

  const handleMetaDataClick = () => {
    setSelectedDealMetaDataOpen(!selectedDealMetaDataOpen);
  };

  const formatTime = (unformatedTime) => {
    const unformattedSplitTime = unformatedTime.split('T');
    const dealYear = unformattedSplitTime[0].slice(0, 4);
    const dealMonth = unformattedSplitTime[0].slice(5, 7);
    const dealDay = unformattedSplitTime[0].slice(8, 10);
    const dealHour = unformattedSplitTime[1].slice(0, 2);
    const dealMinute = unformattedSplitTime[1].slice(3, 5);
    const formattedTime = `${dealMonth}/${dealDay}/${dealYear} ${dealHour}:${dealMinute}`;

    return formattedTime;
  };

  function formatScheduleDate(date, minutesPastMidnight) {
    const zeroPad = (num, places) => String(num).padStart(places, '0');

    const hours = Math.trunc(minutesPastMidnight / 60);
    const minutes = minutesPastMidnight - hours * 60;
    const timeStr = `${zeroPad(hours, 2)}:${zeroPad(minutes, 2)}`;
    const momentDate = new Moment(`${date}T${timeStr}`);
    // console.log('momentDate: ', momentDate);
    return momentDate.format('dddd, MMMM Do, h:mm a');
  }

  let powerMainDisplayAttrs;
  const kwsMainDisplayAttrs = [];
  let imagesMainDisplayAttrs;

  // put power and kws and images attrs into separate objects, they won't render w/ the rest of mainDisplayAttrs later b/c their vals are objects not strings
  for (let i = 0; i < mainDisplayAttrs.length; i++) {
    const attr = mainDisplayAttrs[i];
    // console.log('SelectedDealDisplay attr.val: ', attr.val);

    if (typeof attr.val === 'object') {
      if (attr.val?.type === 'Power') {
        powerMainDisplayAttrs = attr;
      }
      if (attr.val?.type === 'kws') {
        if (attr.val.val !== '' && attr.val.val !== '$ ') {
          kwsMainDisplayAttrs.push({ label: [attr.label], val: attr.val.val });
        }
      }
      if (attr.val?.type === 'ImageList') {
        // console.log('SelectedDealDisplay ImageList attr: ', attr);
        imagesMainDisplayAttrs = attr.val.images;
      }
    }
  }

  // console.log('SelectedDealDisplay mainDisplayAttrs: ', mainDisplayAttrs);
  // console.log(
  //   'SelectedDealDisplay powerMainDisplayAttrs: ',
  //   powerMainDisplayAttrs
  // );
  // console.log('SelectedDealDisplay kwsMainDisplayAttrs: ', kwsMainDisplayAttrs);
  // console.log(
  //   'SelectedDealDisplay imagesMainDisplayAttrs: ',
  //   imagesMainDisplayAttrs
  // );

  return (
    <Box>
      {/* <Box>
        <Typography className={'selected-deal-about-title-text'}>
          About:
        </Typography>
        <Typography className={'selected-deal-about-id-text'}>
          #{metaData.id}
        </Typography>
      </Box> */}
      <Box className="selected-deal-section">
        <Box className={'selected-deal-name-stage-section'}>
          <Typography className={'selected-deal-full-name-text'}>
            {fullName}
          </Typography>
          <Box className={'selected-deal-name-stage-section-right'}>
            <Typography className={'selected-deal-stage-text'}>
              {dealStage}
            </Typography>
            <Button
              disableRipple={true}
              className={'ellipsis-button'}
              onClick={handleSelectedDealOptionsClick}
            >
              <EllipsisIcon></EllipsisIcon>
            </Button>
            {selectedDealOptionsOpen && (
              <DealOptionsMenu
                props={{
                  getData,
                  userId,
                  searchStage,
                  dealTypesCategoryIdMap,
                  dealFilter,
                  categoryId,
                  searchString,
                  fromDealPage,
                  setIsLoaded,
                  metaData,
                  currentOwnerID,
                }}
              ></DealOptionsMenu>
            )}
          </Box>
        </Box>
        <Typography className={'selected-deal-section-header-text'}>
          ABOUT
        </Typography>
        <List>
          {mainDisplayAttrs.length > 0 &&
            mainDisplayAttrs.map((attr, i) => (
              <ListItem
                key={i}
                sx={{
                  padding: 0,
                }}
              >
                {typeof attr.val === 'string' && attr.val !== '' && (
                  <Box className={'selected-deal-attribute-container'}>
                    <Typography
                      className={'selected-deal-attribute-label-text'}
                    >
                      {attr.label}
                      {attr.label !== '' ? ':' : ''}
                    </Typography>
                    <Typography className={'selected-deal-attribute-val-text'}>
                      {attr.val}
                    </Typography>
                  </Box>
                )}
              </ListItem>
            ))}
          <Box className={'selected-deal-attribute-container'}>
            <Typography className={'selected-deal-attribute-label-text'}>
              Setter
            </Typography>
            <Box className={'selected-deal-owner-right'}>
              {ownerProfilePicture ? (
                <Avatar
                  className={'selected-deal-owner-profile-picture'}
                  src={ownerProfilePicture}
                />
              ) : (
                <Avatar className={'selected-deal-owner-profile-picture'}>
                  {initials}
                </Avatar>
              )}
              <Typography className={'selected-deal-owner-text'}>
                {assigneeName}
              </Typography>
            </Box>
          </Box>
        </List>
        {powerMainDisplayAttrs && (
          <>
            <Typography className={'selected-deal-section-header-text'}>
              {powerMainDisplayAttrs.label.toUpperCase()}
            </Typography>
            <List>
              <ListItem
                key={1}
                sx={{
                  padding: 0,
                }}
              >
                <Box className={'selected-deal-attribute-container'}>
                  <Typography className={'selected-deal-attribute-label-text'}>
                    Utility Company
                  </Typography>
                  <Typography className={'selected-deal-attribute-val-text'}>
                    {powerMainDisplayAttrs.val.name}
                  </Typography>
                </Box>
              </ListItem>
              <ListItem
                key={0}
                sx={{
                  padding: 0,
                }}
              >
                <Box className={'selected-deal-attribute-container'}>
                  <Typography className={'selected-deal-attribute-label-text'}>
                    {powerMainDisplayAttrs.val.utilityInfo}
                  </Typography>
                  <Typography className={'selected-deal-attribute-val-text'}>
                    {powerMainDisplayAttrs.val.utilityInfo === 'Annual Usage'
                      ? `${powerMainDisplayAttrs.val.info} KWs`
                      : powerMainDisplayAttrs.val.utilityInfo ===
                        'Average Monthly Cost'
                      ? `${powerMainDisplayAttrs.val.info} KWs/month`
                      : `[MONTHLY USAGE DISPLAY]`}
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </>
        )}
        {kwsMainDisplayAttrs.length > 0 && (
          <>
            <Typography className={'selected-deal-section-header-text'}>
              DEAL
            </Typography>
            {kwsMainDisplayAttrs.map((attr, i) => (
              <ListItem
                key={i}
                sx={{
                  padding: 0,
                }}
              >
                <Box className={'selected-deal-attribute-container'}>
                  <Typography className={'selected-deal-attribute-label-text'}>
                    {attr.label}
                  </Typography>
                  <Typography className={'selected-deal-attribute-val-text'}>
                    {attr.val}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </>
        )}
        <Typography className={'selected-deal-section-header-text'}>
          FREE NOTES
        </Typography>
        <TextareaAutosize
          className={'free-notes-text-area'}
          style={{
            backgroundColor: '#F0F0F3',
            border: 'none',
            borderRadius: 8,
            width: '100%',
            resize: 'none',
            padding: 12,
          }}
          placeholder={'Tap to add'}
        ></TextareaAutosize>
      </Box>
      <Box className={'selected-deal-section-title-container'}>
        <Typography className={'selected-deal-section-title-text'}>
          Appointments
        </Typography>
        <Button
          className={'selected-deal-add-button'}
          onClick={handleAddAppointment}
          disableRipple={true}
        >
          <AddIcon></AddIcon>
        </Button>
      </Box>
      {appointments.length > 0 ? (
        appointments.map((appointment, i) => (
          <Box key={i} className={'selected-deal-appointment-section'}>
            <Box className={'selected-deal-appointment-top-section'}>
              <Box className={'selected-deal-appointment-top-left-container'}>
                <CalendarIcon></CalendarIcon>
                <Typography className={'selected-deal-appointment-date-text'}>
                  {formatScheduleDate(
                    appointment.appointmentDate,
                    appointment.appointmentStartTime
                  )}
                </Typography>
              </Box>
              <Box className={'selected-deal-appointment-top-right-container'}>
                <Button
                  disableRipple={true}
                  className={'ellipsis-button-no-background'}
                  onClick={handleAppointmentOptionsClick}
                >
                  <EllipsisIcon color={'#868686'}></EllipsisIcon>
                </Button>
              </Box>
            </Box>
            <Box className={'selected-deal-appointment-bottom-section'}>
              <Typography className={'selected-deal-appointment-details-text'}>
                {appointment.deal.name}
              </Typography>
              <Typography className={'selected-deal-appointment-details-text'}>
                Assigned to {appointment.user.name}
              </Typography>
              <Typography className={'selected-deal-appointment-details-text'}>
                Setter: {appointment.setter.name}
              </Typography>
              <Typography className={'selected-deal-appointment-details-text'}>
                Status: {appointment.status}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box className={'selected-deal-appointment-section'}>
          <Typography className={'no-appointments-text'}>
            No appointments yet.
          </Typography>
        </Box>
      )}

      <Box className={'selected-deal-section-title-container'}>
        <Typography className={'selected-deal-section-title-text'}>
          Photos
        </Typography>
        <Button
          className={'selected-deal-add-button'}
          onClick={handleAddPhoto}
          disableRipple={true}
        >
          <AddIcon></AddIcon>
        </Button>
      </Box>
      {imagesMainDisplayAttrs ? (
        <Box className={'selected-deal-images-section'}>
          <ImageList
            cols={8}
            gap={8}
            sx={{
              width: '100%',
              marginBottom: 0,
              marginTop: 0,
            }}
          >
            {imagesMainDisplayAttrs.map((image, i) => (
              <ImageListItem
                key={i}
                sx={{
                  width: 'fit-content',
                }}
              >
                <Button
                  className={'image-modal-button'}
                  onClick={handleImageClick}
                  disableRipple={true}
                >
                  <DisplayMedia
                    imageName={image}
                    imageType={'img'}
                    height={'80px'}
                    width={'80px'}
                    objectFit={'cover'}
                    borderRadius={'8px'}
                  ></DisplayMedia>
                </Button>
                <Button
                  className={'delete-image-modal-button'}
                  onClick={handleDeleteImageClick}
                  disableRipple={true}
                >
                  <XIcon></XIcon>
                </Button>
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      ) : (
        <Box className={'selected-deal-no-images-section'}>
          <Typography className={'no-photos-text'}>No photos yet.</Typography>
        </Box>
      )}
      <Box className={'selected-deal-section-title-container'}>
        <Typography className={'selected-deal-section-title-text'}>
          Notes
        </Typography>
      </Box>
      <Box>
        {comments.length > 0 ? (
          comments.map((comment, i) => (
            <Box key={i} className={'selected-deal-comment-section'}>
              <Box className={'selected-deal-comment-top-section'}>
                <Box className={'selected-deal-comment-owner-container'}>
                  {comment.user.profilePicture ? (
                    <Avatar
                      className={'selected-deal-comment-owner-profile-picture'}
                      src={comment.user.profilePicture}
                    />
                  ) : (
                    <Avatar
                      className={'selected-deal-comment-owner-profile-picture'}
                    >
                      {comment.user.initials}
                    </Avatar>
                  )}
                  <Typography className={'selected-deal-comment-owner-text'}>
                    {comment.user.name}
                  </Typography>
                </Box>
                <Box className={'selected-deal-comment-created-at-container'}>
                  <Typography
                    className={'selected-deal-comment-created-at-text'}
                  >
                    {formatTime(comment.createdAt)}
                  </Typography>
                </Box>
              </Box>
              <Box className={'selected-deal-comment-content-container'}>
                <Typography className={'selected-deal-comment-content-text'}>
                  {comment.comment}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Box className={'selected-deal-section'}>
            <Typography className={'no-notes-text'}>No notes yet.</Typography>
          </Box>
        )}
      </Box>
      <Box className={'selected-deal-meta-data-container'}>
        <Button
          className={'selected-deal-meta-data-button'}
          onClick={handleMetaDataClick}
          disableRipple={true}
        >
          <Typography className={'selected-deal-meta-data-button-text'}>
            {selectedDealMetaDataOpen
              ? 'Hide Deal Meta Data'
              : 'Show Deal Meta Data'}
          </Typography>
        </Button>
        {selectedDealMetaDataOpen && (
          <Box className={'selected-deal-meta-data-content-container'}>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                Deal ID:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.id}
              </Typography>
            </Box>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                Created At:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.createdAt}
              </Typography>
            </Box>
            <Typography className={'selected-deal-meta-data-label'}>
              Created By:
            </Typography>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-sub-label'}>
                Name:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.createdBy.name}
              </Typography>
            </Box>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-sub-label'}>
                Email:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.createdBy.email}
              </Typography>
            </Box>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-sub-label'}>
                User ID:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.createdBy.id}
              </Typography>
            </Box>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-sub-label'}>
                User Ext ID:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.createdBy.extID}
              </Typography>
            </Box>
            <Box className={'selected-deal-meta-data-attribute-container'}>
              <Typography className={'selected-deal-meta-data-label'}>
                Updated At:
              </Typography>
              <Typography className={'selected-deal-meta-data-attribute-text'}>
                {metaData.updatedAt}
              </Typography>
            </Box>
            {metaData.updatedBy && (
              <>
                <Typography className={'selected-deal-meta-data-label'}>
                  Updated By:
                </Typography>
                <Box className={'selected-deal-meta-data-attribute-container'}>
                  <Typography className={'selected-deal-meta-data-sub-label'}>
                    Name:
                  </Typography>
                  <Typography
                    className={'selected-deal-meta-data-attribute-text'}
                  >
                    {metaData.updatedBy.name}
                  </Typography>
                </Box>
                <Box className={'selected-deal-meta-data-attribute-container'}>
                  <Typography className={'selected-deal-meta-data-sub-label'}>
                    Email:
                  </Typography>
                  <Typography
                    className={'selected-deal-meta-data-attribute-text'}
                  >
                    {metaData.updatedBy.email}
                  </Typography>
                </Box>
                <Box className={'selected-deal-meta-data-attribute-container'}>
                  <Typography className={'selected-deal-meta-data-sub-label'}>
                    User ID:
                  </Typography>
                  <Typography
                    className={'selected-deal-meta-data-attribute-text'}
                  >
                    {metaData.updatedBy.id}
                  </Typography>
                </Box>
                <Box className={'selected-deal-meta-data-attribute-container'}>
                  <Typography className={'selected-deal-meta-data-sub-label'}>
                    User Ext ID:
                  </Typography>
                  <Typography
                    className={'selected-deal-meta-data-attribute-text'}
                  >
                    {metaData.updatedBy.extID}
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>
      <Box className="selected-deal-bottom-section"></Box>
    </Box>
  );
}
